import React from 'react';
import { COMPANY_LEGAL_INFO } from '../../constants/legal';

const CompanyInfo = () => {
  return (
    <section className="mb-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Company Information</h2>
      <ul className="space-y-2 text-gray-600">
        <li><strong>Company Name:</strong> {COMPANY_LEGAL_INFO.name}</li>
        <li><strong>Legal Form:</strong> {COMPANY_LEGAL_INFO.legalForm}</li>
        <li><strong>SIREN:</strong> {COMPANY_LEGAL_INFO.siren}</li>
        <li><strong>SIRET:</strong> {COMPANY_LEGAL_INFO.siret}</li>
        <li><strong>RCS Number:</strong> {COMPANY_LEGAL_INFO.rcsDetails}</li>
        <li><strong>VAT Number:</strong> {COMPANY_LEGAL_INFO.vatNumber}</li>
        <li><strong>Share Capital:</strong> {COMPANY_LEGAL_INFO.shareCapital}</li>
        <li><strong>Registered Office:</strong> {COMPANY_LEGAL_INFO.address.street}, {COMPANY_LEGAL_INFO.address.postalCode} {COMPANY_LEGAL_INFO.address.city}, {COMPANY_LEGAL_INFO.address.country}</li>
        <li><strong>Main Activity:</strong> {COMPANY_LEGAL_INFO.activity} (Code {COMPANY_LEGAL_INFO.activityCode})</li>
        <li><strong>Legal Representative:</strong> {COMPANY_LEGAL_INFO.legalRepresentative}</li>
        <li><strong>Position:</strong> {COMPANY_LEGAL_INFO.position}</li>
        <li><strong>RCS Registration:</strong> {COMPANY_LEGAL_INFO.registrations.rcs.status} ({COMPANY_LEGAL_INFO.registrations.rcs.location}, le {COMPANY_LEGAL_INFO.registrations.rcs.date})</li>
        <li><strong>RNE Registration:</strong> {COMPANY_LEGAL_INFO.registrations.rne}</li>
      </ul>
    </section>
  );
};

export default CompanyInfo;